if (process.env.NODE_ENV === 'production') {
  module.exports = require('./css-longhand.production.js');
} else {
  module.exports = require('./css-longhand.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/css-longhand/dist/es/css-longhand.js
// module id = 33
// module chunks = 0